import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { sanitizarHtmlEmail } from '../../features/tickets';

// Cuerpo HTML de un comentario entrado por email. El HTML pasa SIEMPRE por
// sanitizarHtmlEmail (DOMPurify + contrato adjunto:<id>) antes de volcarse al
// DOM; ver features/tickets/emailHtml.js. El contenido citado (respuestas
// anteriores) viene sin recortar en el HTML: se colapsa por CSS y se ofrece un
// toggle para verlo.
const EmailHtmlBody = ({ html, adjuntos }) => {
  const [citadoVisible, setCitadoVisible] = useState(false);

  // adjuntos refresca cada pocos segundos (URLs firmadas que caducan): el memo
  // se recalcula con cada lista nueva y nunca se cachea una URL vencida.
  const { html: htmlSeguro, tieneCitado } = useMemo(
    () => sanitizarHtmlEmail(html, adjuntos),
    [html, adjuntos],
  );

  if (!htmlSeguro) return null;

  return (
    <div className={`tickets-html${citadoVisible ? ' tickets-html--citado-visible' : ''}`}>
      <div
        className="tickets-html__cuerpo"
        // Saneado justo arriba con DOMPurify; no llega HTML crudo aquí.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: htmlSeguro }}
      />
      {tieneCitado && (
        <button
          type="button"
          className="tickets-html__toggle"
          onClick={() => setCitadoVisible((v) => !v)}
        >
          {citadoVisible ? 'Ocultar contenido citado' : 'Mostrar contenido citado'}
        </button>
      )}
    </div>
  );
};

EmailHtmlBody.propTypes = {
  html: PropTypes.string.isRequired,
  adjuntos: PropTypes.arrayOf(PropTypes.object),
};

EmailHtmlBody.defaultProps = {
  adjuntos: [],
};

export default EmailHtmlBody;
